export const MARKETPLACE_HOMEPAGE_ROUTES = {
  ROOT: '/marketplace',
  BROWSE: '/marketplace',
} as const;
